import Drift from 'drift-zoom';

function ProductGallery() {
  const self = this;

  self.init = function init(element) {
    const $wrap = $(element);

    if ($wrap.data('app-module-initialized')) return; // Prevent double init

    const $zoom = $wrap.find('.js-product-gallery__zoom');
    const $viewImage = $wrap.find('.js-product-gallery__view-image');

    $wrap.on('click', '.js-product-gallery__thumb', function toggleImage(e) {
      e.preventDefault();

      const $thumb = $(this);

      if ($thumb.hasClass('is-selected')) return;

      const src = $thumb.attr('href');
      const zoomSrc = $thumb.data('zoom-src') ? $thumb.data('zoom-src') : src;

      $wrap.find('.js-product-gallery__thumb.is-selected').removeClass('is-selected');

      $viewImage
        .attr('src', src)
        .attr('data-zoom', zoomSrc);

      $thumb.addClass('is-selected');
    });

    // temporary fix: валился с ошибкой, когда на странице нет .js-product-gallery__thumb
    const $thumb = $wrap.find('.js-product-gallery__thumb');
    if ($thumb.length) {
      $thumb.get(0).click();
    }

    new Drift($viewImage[0], {
      paneContainer: $zoom[0],
      onShow() {
        $zoom.show();
      },
      onHide() {
        $zoom.hide();
      },
    });

    $wrap.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-product-gallery').each(function init() {
      self.init(this);
    });
  };
}

export default new ProductGallery();
